import { Badge, Button, CircularProgress, Input, Link, List, ListItem, ListItemButton, ListItemContent, ListItemDecorator, Modal, ModalClose, Sheet, Stack, Switch, Table, Typography } from "@mui/joy";

//componentes
import Header from "../../../../components/Header";
import Sidebar from "../../../../components/Sidebar";
import { useMediaQuery } from "@mui/material";
import { FaUser, FaFilePdf } from "react-icons/fa";
import { useEffect, useState } from "react";
import { api } from "../../../../services/api";
import { dataAtual, diferencaEmDias, formatarDataHoraBrasil } from "../../../../utils/datas";
import { jsPDF } from "jspdf";

export default function ProcessosPorUsuario() {

    const permissoes = JSON.parse(localStorage.getItem('usuario')).user.autenticacao;
    const usuarioComprador = permissoes.includes("compras");

    const mobile = useMediaQuery('(max-width:1200px)');
    const [modalProcessos, setModalProcessos] = useState(false);
    const [processos, setProcessos] = useState([]);
    const [processosUsuario, setProcessosUsuario] = useState([]);
    const [processoSelecionado, setProcessoSelecionado] = useState([]);
    const [processoSelecionadoUsuario, setProcessoSelecionadoUsuario] = useState([]);
    const [nomeSelecionado, setNomeSelecionado] = useState('');
    const [somenteCompradores, setSomenteCompradores] = useState(true);
    const [nomeUsuario, setNomeUsuario] = useState('');
    const [loading, setLoading] = useState(true);
    const [loadingPDF, setLoadingPDF] = useState(false);

    useEffect(() => {
        obterProcessos();
    }, []);

    useEffect(() => {
        setLoading(true);
        obterProcessos();
    }, [somenteCompradores]);

    const obterProcessos = async () => {
        if (somenteCompradores) {
            const response = await api.get('/processosPorComprador');
            if (response.status === 200) {
                // Agrupar os dados por comprador
                const groupedData = response.data.reduce((acc, item) => {
                    const key = item.comprador;
                    if (!acc[key]) {
                        acc[key] = {
                            comprador: key,
                            user_id: item.user_id,
                            solicitacoes: [],
                            total_cotacoes: 0
                        };
                    }
                    acc[key].solicitacoes.push(item);
                    acc[key].total_cotacoes += 1;
                    return acc;
                }, {});
                const groupedArray = Object.values(groupedData);

                if (!permissoes.includes('gestao') && usuarioComprador) {
                    const idComprador = JSON.parse(localStorage.getItem("usuario")).user.id;
                    const filteredData = groupedArray.filter(r => r.user_id == idComprador);
                    setProcessos(filteredData);
                    if (filteredData.length > 0) {
                        setProcessoSelecionado(filteredData[0].solicitacoes);
                    } else {
                        setProcessoSelecionado([]);
                    }
                } else {
                    setProcessos(groupedArray);
                }
            }
            setLoading(false);
            return;
        }

        const response = await api.get('/processosPorAprovador?nome_usuario=' + nomeUsuario);
        if (response.status === 200) {
            // Agrupar os dados por nome do usuário
            const groupedData = response.data.reduce((acc, item) => {
                const key = item.nome;
                if (!acc[key]) {
                    acc[key] = {
                        nome_usuario: key,
                        solicitacoes: []
                    };
                }
                acc[key].solicitacoes.push(item);
                return acc;
            }, {});
            const groupedArray = Object.values(groupedData);
            
            // Remover usuários não identificados
            const filteredArray = groupedArray.filter(p => p.nome_usuario !== 'Não identificado');
            
            setProcessosUsuario(filteredArray);
            setLoading(false);
        }
    }

    const selecionarProcesso = async (index) => {
        if (somenteCompradores) {
            setProcessoSelecionado(processos[index].solicitacoes);
            setNomeSelecionado(processos[index].comprador);
        }
        else {
            setProcessoSelecionadoUsuario(processosUsuario[index].solicitacoes);
            setNomeSelecionado(processosUsuario[index].nome_usuario);
        }
        setModalProcessos(true);
    }

    const gerarPDF = async () => {
        setLoadingPDF(true);
        const element = document.getElementById('tabela-processos-pdf');
        const newWindow = window.open('', '_blank');
        if (!newWindow) {
            console.error('Não foi possível abrir nova aba para o PDF.');
            setLoadingPDF(false);
            return;
        }

        try {
            const doc = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });
            const margin = 10;
            const pageWidth = doc.internal.pageSize.getWidth();
            const pdfWidth = pageWidth - margin * 2;

            await doc.html(element, {
                x: margin,
                y: margin,
                width: pdfWidth,
                html2canvas: {
                    scale: 0.24,
                    useCORS: true
                }
            });

            const pdfBlob = doc.output('blob');
            const pdfUrl = URL.createObjectURL(pdfBlob);
            newWindow.location.href = pdfUrl;
        } catch (error) {
            console.error('Erro ao gerar PDF:', error);
            newWindow.close();
        } finally {
            setLoadingPDF(false);
        }
    }

    return (
        <Stack backgroundColor="#F5F5F5" height="100vh">
            <Header mobile={mobile} />
            <Sidebar mobile={mobile} />

            <Stack ml={mobile ? "0px" : "280px"} mt="50px" overflow={"auto"} height={mobile ? "100%" : "calc(100vh - 200px)"} p={mobile ? "20px" : "50px"}>
                {!permissoes.includes('gestao') && usuarioComprador ?
                    <Stack sx={{ backgroundColor: '#eee', borderRadius: '10px', padding: '10px 20px' }}>
                        <Typography fontSize={20} fontWeight={'bold'} sx={{ color: '#1565c0' }}>Solicitações Pendentes</Typography>
                        <Typography sx={{ color: "#444" }}>Veja todas as solicitações aguardando por você</Typography>
                    </Stack>
                    :
                    <Stack sx={{ backgroundColor: '#eee', borderRadius: '10px', padding: '10px 20px' }}>
                        <Typography fontSize={20} fontWeight={'bold'} sx={{ color: '#1565c0' }}>Solicitações Pendentes por Usuário</Typography>
                        <Typography sx={{ color: "#444" }}>Visualize usuários com solicitações aguardando aprovação</Typography>
                    </Stack>
                }
                {permissoes.includes('gestao') &&
                    <Stack gap={'30px'} alignItems={'flex-end'} flexDirection={'row'} mt={'20px'}>
                        <Stack sx={mobile ? { width: 'auto' } : { width: '400px' }}>
                            <Typography sx={{ color: "#444" }}>Nome do usuário</Typography>
                            <Input value={nomeUsuario} onChange={e => setNomeUsuario(e.target.value)} placeholder='Informe o nome da pessoa' />
                        </Stack>
                        <Stack alignItems={'center'}>
                            <Typography sx={{ marginBottom: '10px', color: "#444" }}>Somente etapa comprador</Typography>
                            <Switch
                                checked={somenteCompradores}
                                onChange={(event) => setSomenteCompradores(event.target.checked)}
                            />
                        </Stack>
                    </Stack>
                }
                {loading ?
                    <Stack sx={{ flex: 1, width: "500px", justifyContent: "center", alignItems: 'center' }}>
                        {/* <p>Carregando...</p> */}
                        <CircularProgress />
                        <Typography>{usuarioComprador ? 'Procurando processos...' : 'Consultando usuários...'}</Typography>
                    </Stack>
                    :
                    <Stack mt={"20px"}>
                        {somenteCompradores ?
                            (!permissoes.includes('gestao') && usuarioComprador) ?
                                <Stack>
                                    <Table aria-label="basic table" sx={{ width: "700px" }}>
                                        <thead>
                                            <tr>
                                                <th style={{ width: "60px" }}>Cotação</th>
                                                <th style={{ width: "80px", textAlign: "center" }}>Solicitação</th>
                                                <th style={{ width: "100px", textAlign: "center" }}>N° 1.1.06</th>
                                                <th style={{ width: "100px", textAlign: "center" }}>Data e hora de chegada</th>
                                                <th style={{ width: "90px", textAlign: "center" }}>Permanência em dias</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {somenteCompradores ?
                                                processoSelecionado.map((processo, index) => {
                                                    return (
                                                        <tr key={index}>
                                                            <td style={{padding: 0}}>{processo.id_cot_sol}</td>
                                                            <td style={{padding: 0, textAlign: "center"}}><Link onClick={() => window.open('solicitacao/' + processo.cotacoes_id)}>{processo.cotacoes_id}</Link></td>
                                                            <td style={{padding: 0, textAlign: "center"}}><Link onClick={() => window.open('aprovacaoCompras/' + processo.numeroMov6)}>{processo.numeroMov6}</Link></td>
                                                            <td style={{padding: 0, textAlign: "center"}}>{formatarDataHoraBrasil(processo.updated_at).replace(",", " as ")}</td>
                                                            <td style={{ textAlign: "center", padding: 0 }}>{diferencaEmDias(processo.updated_at.split(" ")[0], dataAtual())}</td>
                                                        </tr>
                                                    );
                                                })
                                                :
                                                processoSelecionadoUsuario.map((processo, index) => {
                                                    return (
                                                        <tr key={index}>
                                                            <td style={{padding: 0}}>{processo.id}</td>
                                                            <td style={{padding: 0, textAlign: "center"}}><Link onClick={() => window.open('solicitacao/' + processo.id)}>{processo.id}</Link></td>
                                                            <td style={{padding: 0, textAlign: "center"}}>{processo.etapaAtual}</td>
                                                            <td style={{padding: 0, textAlign: "center"}}>{processo.localEstoque}</td>
                                                            <td style={{padding: 0, textAlign: "center"}}>{processo.tipo}</td>
                                                        </tr>
                                                    );
                                                })
                                            }
                                        </tbody>
                                    </Table>
                                </Stack>
                                :
                                <List>
                                    {processos.map((processo, index) => {
                                        return (
                                            <ListItem key={index} sx={{ width: "500px", borderBottom: "1px solid #ddd" }}>
                                                <ListItemButton onClick={() => selecionarProcesso(index)}>
                                                    <ListItemDecorator><FaUser /></ListItemDecorator>
                                                    <ListItemContent>{processo.comprador}</ListItemContent>
                                                    <Badge badgeContent={processo.total_cotacoes} color="warning" sx={{ marginRight: "10px" }} />
                                                </ListItemButton>
                                            </ListItem>
                                        );
                                    })}
                                </List>
                            :
                            <List>
                                {processosUsuario.map((processo, index) => {
                                    if (processo.nome_usuario && (processo.nome_usuario?.toLowerCase().includes(nomeUsuario?.toLowerCase()) || nomeUsuario.length == 0)) {
                                        return (
                                            <ListItem key={index} sx={{ width: "500px", borderBottom: "1px solid #ddd" }}>
                                                <ListItemButton onClick={() => selecionarProcesso(index)}>
                                                    <ListItemDecorator><FaUser /></ListItemDecorator>
                                                    <ListItemContent>{processo.nome_usuario}</ListItemContent>
                                                    <Badge badgeContent={processo.solicitacoes.length} color="warning" />
                                                </ListItemButton>
                                            </ListItem>
                                        );
                                    }
                                })}
                            </List>
                        }
                    </Stack>
                }
            </Stack>

            <Modal
                aria-labelledby="modal-title"
                aria-describedby="modal-desc"
                open={modalProcessos}
                disableScrollLock={true}
                onClose={() => setModalProcessos(false)}
                sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
            >
                <Sheet
                    variant="outlined"
                    sx={{
                        minWidth: mobile ? "70%" : "auto",
                        maxWidth: "80%",
                        maxHeight: "80%",
                        borderRadius: 'md',
                        p: 3,
                        boxShadow: 'lg',
                        overflowY: "auto",
                        overflowX: "hidden"
                    }}
                >
                    <Stack direction="row" justifyContent="space-between" alignItems="flex-start" mb={2}>
                        <ModalClose
                            variant="outlined"
                            sx={{
                                top: 'calc(0.3 * var(--IconButton-size))',
                                right: 'calc(0.3 * var(--IconButton-size))',
                                boxShadow: '0 2px 12px 0 rgba(0 0 0 / 0.2)',
                                borderRadius: '50%',
                                bgcolor: 'background.surface',
                            }}
                        />
                        <Button
                            startDecorator={loadingPDF ? <CircularProgress size="sm" /> : <FaFilePdf />}
                            onClick={gerarPDF}
                            variant="solid"
                            color="danger"
                            disabled={loadingPDF}
                        >
                            {loadingPDF ? 'Gerando PDF...' : 'Gerar PDF'}
                        </Button>
                    </Stack>
                    <div id="tabela-processos-pdf">
                        <Typography
                            component="h2"
                            id="modal-title"
                            level="h4"
                            textColor="inherit"
                            fontWeight="normal"
                            mb={1}
                            sx={{ color: "#333" }} >
                            {somenteCompradores ?
                                <div>
                                    <label style={{ fontWeight: "bold" }}>{processoSelecionado.length}</label> processos aguardando <label style={{ fontWeight: "bold" }}>{nomeSelecionado}</label>
                                </div>
                                :
                                <div>
                                    <label style={{ fontWeight: "bold" }}>{processoSelecionadoUsuario.length}</label> processos aguardando <label style={{ fontWeight: "bold" }}>{nomeSelecionado}</label>
                                </div>
                            }
                        </Typography>
                        <Stack>
                            <Stack>
                                <Table aria-label="basic table" sx={{ width: "800px" }}>
                                    <thead>
                                        <tr>
                                            <th style={{ width: "70px" }}>Cotação</th>
                                            <th style={{ width: "80px", textAlign: "center" }}>Solicitação</th>
                                            <th style={{ width: "60px", textAlign: "center" }}>N° 1.1.06</th>
                                            <th style={{ textAlign: "center" }}>Etapa atual</th>
                                            <th style={{ width: "160px", textAlign: "center" }}>Data e hora de chegada</th>
                                            <th style={{ width: "130px", textAlign: "center" }}>Permanência (dias)</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {somenteCompradores ?
                                            processoSelecionado.map((processo, index) => {
                                                return (
                                                    <tr key={index}>
                                                        <td style={{padding: 0}}>{processo.numeroMov6 ? processo.cotacoes_id : ""}</td>
                                                        <td style={{padding: 0, textAlign: "center"}}><Link onClick={() => window.open('solicitacao/' + processo.id_cot_sol)}>{processo.id_cot_sol}</Link></td>
                                                        <td style={{padding: 0, textAlign: "center"}}><Link onClick={() => window.open('aprovacaoCompras/' + processo.numeroMov6)}>{processo.numeroMov6}</Link></td>
                                                        <td style={{padding: 0, textAlign: "center"}}>{processo.etapaAtual}</td>
                                                        <td style={{padding: 0, textAlign: "center"}}>{formatarDataHoraBrasil(processo.updated_at).replace(",", " as ")}</td>
                                                        <td style={{ textAlign: "center", padding: 0 }}>{diferencaEmDias(processo.updated_at.split(" ")[0], dataAtual())}</td>
                                                    </tr>
                                                );
                                            })
                                            :
                                            processoSelecionadoUsuario.map((processo, index) => {
                                                return (
                                                    <tr key={index}>
                                                        <td style={{padding: 0}}>{processo.codCotacao}</td>
                                                        <td style={{padding: 0, textAlign: "center"}}><Link onClick={() => window.open('solicitacao/' + processo.id)}>{processo.id}</Link></td>
                                                        <td style={{padding: 0, textAlign: "center"}}><Link onClick={() => window.open('aprovacaoCompras/' + processo.numeroMov6)}>{processo.numeroMov6}</Link></td>
                                                        <td style={{padding: 0, textAlign: "center"}}>{processo.etapaAtual}</td>
                                                        <td style={{padding: 0, textAlign: "center"}}>{formatarDataHoraBrasil(processo.updated_at).replace(",", " as ")}</td>
                                                        <td style={{padding: 0, textAlign: "center"}}>{diferencaEmDias(processo.updated_at.split(" ")[0], dataAtual())}</td>
                                                        {/* <td style={{padding: 0, textAlign: "center"}}>{diferencaEmDias(processo.updated_at.split(" ")[0], dataAtual())}</td> */}
                                                    </tr>
                                                );
                                            })
                                        }
                                    </tbody>
                                </Table>
                            </Stack>
                        </Stack>
                    </div>
                </Sheet>
            </Modal>
        </Stack >
    );
}